define('v3/Common/Components/CollapsiblePanel/CollapsiblePanel.Component',[
	'knockout',
	'lodash',
	'text!v3/Common/Components/CollapsiblePanel/CollapsiblePanel.Component.html',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/HeightAnimation.Binding'
], function (ko, _, htmlString) {
	var validateParams = function (params) {
		if (!ko.isWritableObservable(params.expanded)) {
			throw new Error('params.expanded should be a writable observable');
		}
	};

	function CollapsiblePanel (params) {
		var self = this;

		validateParams(params);

		self.data = params.data;
		self.isAnimating = params.isAnimating;
		self.hideCollapsedContent = ko.observable(false);

		self.onAnimationEndCallback = function (element) { // params.onAnimationEnd;
			if (params.onAnimationEnd) { params.onAnimationEnd(element); }

			if (!self.expanded()) { self.hideCollapsedContent(true); } else { self.hideCollapsedContent(false); }
		};

		self.showLoaderInHeaderAndCollapseContent = ko.computed(function () {
			return ko.unwrap(params.showLoaderInHeaderAndCollapseContent);
		});
		self.expanded = params.expanded;
		self.toggle = function () {
			self.expanded(!self.expanded());
		};

		self.dispose = function () {
			self.showLoaderInHeaderAndCollapseContent.dispose();
		};

		self.find = _.find;
	}

	return { viewModel: CollapsiblePanel, template: htmlString };
});

